export default __webpack_public_path__ + "static/media/ifttt.a57b69ac.svg";